/* istanbul ignore file */
import { useUiTheme } from 'framework/uiTheme';
import type { FormPageLayoutProps } from '../../FormPageLayout/FormPageLayout';

const CreatePageLayout = (props: FormPageLayoutProps) => {
  const { FormPageLayout } = useUiTheme<ReactComponent<FormPageLayoutProps>>();

  return <FormPageLayout {...props} />;
};

export default CreatePageLayout;
